export enum PromotionStatusEnum {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  STARTED = 'STARTED',
  REJECTED = 'REJECTED',
  CLOSED = 'CLOSED',
}
